import type { SpacerContent } from '@/blocks/domain/types';
import type { RendererProps } from '../../domain/RendererContract';
import { AtomicBlockWrapper } from '@/document-render/presentation/primitives/AtomicBlockWrapper';

interface Props extends RendererProps<SpacerContent> {}

function SpacerRenderImpl({ content }: Props) {
  return (
    <AtomicBlockWrapper ariaLabel="block-spacer">
      <div style={{ height: content.heightPx }} />
    </AtomicBlockWrapper>
  );
}

export const renderer = {
  Component: SpacerRenderImpl,
  flowBehavior: 'atomic' as const
};

export type { SpacerContent };
